import { InterInstance } from '@api/config';

export const createContact = async (token: string, quote: any) => {
  try {
    const { data } = await InterInstance({
      method: 'post',
      url: '/crm/contact',
      headers: { Authorization: `Bearer ${token}` },
      data: quote,
    });
    return data;
  } catch (e) {
    return e;
  }
};
